import UnifyAiLoader from '../CopilotChat/components/UnifyAiLoader';
import type { LoaderComponentProps } from './types';

function AILoader(_: LoaderComponentProps) {
  return <UnifyAiLoader height={24} width={24} />;
}

export default AILoader;
